export const SIMPLE_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const ISO8601_DATE_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}?(:\d{2})?(\.\d{2,3})?Z?$/;
